import { createSelector } from "reselect";
import { getStorageInboundCreate } from "./getStorageInboundCreate";

export const getSelectedProductCasePacks = createSelector(
  getStorageInboundCreate,
  (state) => state.selectedProductsCasePacks
);
